export default {
	vipBenefits: {
		salaryTitle: 'VIP Salary',
		benefitsTitle: 'Benefits',
		yourVipProgress: 'Your VIP Progress',
		progressToVip: '{percent}% until VIP {level}',
		vipMax: 'Max Level Reached',
		vipLevelBenefits: 'VIP Level & Benefits',
		betXpRule: 'Bet {amount} = {xp}EXP',
		btnReceive: 'Claim',
		btnJoinIn: 'Join In',
		btnReceived: 'Received',
		btnExpired: 'Expired',
		btnNotSettled: 'Not Settled',
		btnComingSoon: 'Coming Soon',
		btnViewMore: 'View More',
		btnContactNow: 'Contact Now',
		guestTitleLevelup: 'Level Up Bonus',
		guestTitleDaily: 'Daily Salary',
		guestTitleWeekly: 'Weekly Salary',
		guestTitleMonthly: 'Monthly Salary',
		guestTitleCashback: 'Cashback',
		guestTitleRescue: 'Rescue Bonus',
		guestTitleEvents: 'VIP Events',
		guestTitleSupport: 'VIP Support',
		guestDescLevelup: 'Get a one-time bonus each time you reach a new VIP level.',
		guestDescDaily: 'Claim a daily salary reward as your VIP level grows.',
		guestDescWeekly: 'Claim a weekly salary reward as your VIP level grows.',
		guestDescMonthly: 'Claim a monthly salary reward as your VIP level grows.',
		guestDescCashback: 'Earn cashback on your game spending.',
		guestDescRescue: 'Get a rescue bonus to help you bounce back.',
		guestDescEvents: 'Higher VIP levels unlock more exclusive event rewards.',
		guestDescSupport: 'Dedicated VIP support for faster assistance.',
		comingSoonHint: 'Benefit coming soon, please stay tuned',
		receiveSuccess: 'Reward received',
		receiveFailed: 'Failed to receive reward',
		typeUpgrade: 'Level Up Bonus',
		typeDailySalary: 'Daily Salary',
		typeWeeklySalary: 'Weekly Salary',
		typeMonthlySalary: 'Monthly Salary',
		typeRebate: 'Cashback',
		typeRescue: 'Rescue Bonus',
		typeVipActivity: 'VIP Events',
		typeVipService: 'VIP Support',
		tooltipRecharge: 'Recharge {current}/{target}',
		tooltipBets: 'Bets {current}/{target}',
		progressRecharge: 'Recharge',
		progressBets: 'Bets',
		descUpgradeBonus: 'VIP{level} Upgrade Bonus ×{count}',
		descDailySalary: 'VIP{level} Daily Salary ×{count}',
		descWeeklySalary: 'VIP{level} Weekly Salary ×{count}',
		descMonthlySalary: 'VIP{level} Monthly Salary ×{count}',
		descUpgradeBonusPlain: 'VIP{level} Upgrade Bonus',
		descDailySalaryPlain: 'VIP{level} Daily Salary',
		descWeeklySalaryPlain: 'VIP{level} Weekly Salary',
		descMonthlySalaryPlain: 'VIP{level} Monthly Salary',
		descRebate: 'VIP{level} Game Cashback',
		descRescue: 'VIP{level} Rescue Bonus',
		descVipActivity: 'Higher VIP levels unlock more exclusive event rewards.',
		descVipService: 'Dedicated VIP support for faster assistance.',
		allBenefits: 'All Benefits',
		vipClubTitle: 'VIP Club',
		more: 'More',
		moreDesc: 'Please see our promotions for more details.',
		promotions: 'Promotions',
		highlightsTitle: '8 Feature Highlights',
		highlightSupport: 'Exclusive VIP Support',
		highlightLevelup: 'Level Up Bonus',
		highlightSalary: 'VIP Salary',
		highlightRescue: 'VIP Rescue Bonus',
		highlightGifts: 'Exclusive\nVIP Gifts',
		highlightEvents: 'VIP Events',
		highlightService: 'Dedicated\nVIP Service',
		highlightWallet: 'VIP\nCredit Wallet',
		currentLevel: 'Current Level',
		keepPlayingReach: 'Keep playing to reach',
		higherLevelRewards: 'Higher level, greater rewards',
		levelUpUnlock: 'Level up to unlock exclusive benefits and enjoy premium experience.',
		yourVipBenefits: 'Your VIP Benefits',
		viewVipLevels: 'View VIP Levels',
		exclusiveBenefitsTitle: 'Your Exclusive Benefits',
		tipExclusiveRewards: 'Exclusive\nRewards',
		tipHigherRakeback: 'Higher\nRakeback',
		tipPrioritySupport: 'Priority\nSupport',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'Level',
		tableRequiredXp: 'Required XP',
		tableLevelUpBonus: 'Level up bonus',
		tableDailyRakeback: 'Daily Rakeback',
		tableWeeklyLossback: 'Weekly Lossback',
		signIn: 'Sign In',
		vipClubDefaultDesc: 'Join our VIP Club now and get ready to be showered with gifts, giveaways, and amazing features.',
	},
};
